import React from 'react';
import { Container } from '@fiverr-private/layout_components';
import { Tooltip } from '@fiverr-private/tooltip';
import { QuestionMarkIcon } from '@fiverr-private/visuals';
import { translate } from '@fiverr-private/i18n-react';

export const AggregatedRatingTooltip: React.FC = () => {
  const tooltipText = translate('seo_content.aggregated_rating.tooltip');

  return (
    <Tooltip content={tooltipText} position="bottom">
      <Container display="inlineFlex" marginLeft="2" position="relative" top="3px">
        <QuestionMarkIcon size="sm" color="grey_1100" />
      </Container>
    </Tooltip>
  );
};
